import { clamp } from './math';
import PopoverPosition from './PopoverPosition';

interface IRect {
  width: number;
  height: number;
}

interface IPositionedRect extends IRect {
  top: number;
  left: number;
}

export default function getPopoverCoordinates(
  targetRect: IPositionedRect,
  popoverRect: IRect,
  container: IRect,
  margin: number = 0,
) {
  const minPopoverX = margin;
  const minPopoverY = margin;
  const maxPopoverX = container.width - popoverRect.width - margin;
  const maxPopoverY = container.height - popoverRect.height - margin;

  const centeredX = getCenteredX(targetRect, popoverRect, minPopoverX, maxPopoverX);
  const centeredY = getCenteredY(targetRect, popoverRect, minPopoverY, maxPopoverY);

  let x;
  let y;
  let position: PopoverPosition;

  if (targetRect.top - popoverRect.height - margin >= minPopoverY) {
    position = PopoverPosition.Above;
    x = centeredX;
    y = targetRect.top - popoverRect.height - margin;
  } else if (targetRect.left + targetRect.width + margin <= maxPopoverX) {
    position = PopoverPosition.Right;
    x = targetRect.left + targetRect.width + margin;
    y = centeredY;
  } else if (targetRect.left - popoverRect.width - margin >= minPopoverX) {
    position = PopoverPosition.Left;
    x = targetRect.left - popoverRect.width - margin;
    y = centeredY;
  } else {
    position = PopoverPosition.Below;
    x = centeredX;
    y = targetRect.top + targetRect.height + margin;

    const verticalOverhang = container.height - y - popoverRect.height;

    if (verticalOverhang < 0) {
      position = PopoverPosition.Cover;
      y += verticalOverhang;
    }
  }

  return { x, y, position };
}

function getCenteredX(targetRect: IPositionedRect, popoverRect: IRect, min: number, max: number) {
  const value = (targetRect.left + (targetRect.width * 0.5)) - (popoverRect.width * 0.5);

  return clamp(value, min, max);
}

function getCenteredY(targetRect: IPositionedRect, popoverRect: IRect, min: number, max: number) {
  const value = (targetRect.top + (targetRect.height * 0.5)) - (popoverRect.height * 0.5);

  return clamp(value, min, max);
}
